<template>
<div>
<Tasks/>

</div>
</template>

<script>
import Tasks from "../../components/Applicant/Tasks.vue";


export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   Tasks
  },
  created() {

  }
};
</script>

<style scoped>


</style>